import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useWorkspaceAccess } from './useWorkspaceAccess'

export function useWorkspaceStaffGuard(areaLabel = 'esta área') {
  const route = useRoute()
  const router = useRouter()
  const workspaceAccess = useWorkspaceAccess()
  const ready = ref(false)

  const staffDenied = computed(() => {
    if (!ready.value) return false
    if (workspaceAccess.canManageWorkspaceSettings.value) return false
    return true
  })

  const ensureAccess = async (workspaceId) => {
    if (!workspaceId) {
      ready.value = true
      return
    }
    await workspaceAccess.loadRoleForWorkspace(workspaceId)
    ready.value = true
    if (workspaceAccess.canManageWorkspaceSettings.value && route.query.staffDenied === '1') {
      const { staffDenied: _removed, ...rest } = route.query
      router.replace({ path: route.path, query: rest })
    }
  }

  watch(
    () => route.params.id,
    (id) => {
      ready.value = false
      if (id) ensureAccess(id)
    },
    { immediate: true }
  )

  return {
    areaLabel,
    staffDenied,
    ready,
    workspaceAccess,
    ensureAccess
  }
}
